
const MISCELLANEOUS = {
    pageDataAid: "followUs",
    pageTitle: {
        text: 'Follow us',
        dataAid: "followUs"
    },
}

const CONTENT  = {
    onePercent: {
        title: {
            text: 'One percent academy'
        }
    },
    telegram: {
        title: {
            text: "Telegram"
        }
    },
    youtube: {
        title: {
            text: "YouTube"
        }
    },
    instagram: {
        title: {
            text: "Instagram"
        }
    },
    facebook: {
        title: {
            text: "Facebook"
        }
    },
    twitter: {
        title: {
            text: "Twitter"
        }
    }
}


const FOLLOW_US = {
    ...MISCELLANEOUS,
    CONTENT
}


export default FOLLOW_US
